
import { React, useState,useContext,useEffect } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography } from '@mui/material';
import axios from 'axios';
const DisclaimerDialog = ({ open, onAgree, onLogout }) => {
  const [disclaimer, setdisclaimer] = useState('');
  useEffect(() => {
      const fetchData = async () => {
        try {
          await Promise.all([getdynamicdata()]);
        } catch (error) {
          console.error(error);
        } finally {
        }
      };
      fetchData();
    }, []);
  const getdynamicdata = async () => {
      const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/getdisclaimertest`);
      setdisclaimer(res.data[0].fieldvalue);
    };
  return (
    <Dialog open={open} disableEscapeKeyDown>
      <DialogTitle>Disclaimer</DialogTitle>
      <DialogContent dividers>
        <Typography gutterBottom>
          {disclaimer || "By using this platform, you agree to our terms of service and acknowledge that all data is shared in good faith."}
        </Typography>
        <Typography variant="body2" color="textSecondary">
          You must accept the disclaimer to access community content.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" onClick={onAgree} color="primary">I Agree</Button>
        <Button variant="outlined" onClick={onLogout} color="error">Logout</Button>
      </DialogActions>
    </Dialog>
  );
};

export default DisclaimerDialog;
